import { useEffect } from "react";
import './home.less'
// import { store } from '@/store'
// import { getAppQrcode } from "@/api/app-qrcode";

const Home = () => {
  // const [height, setHeight] = useState(window.innerHeight);
  // const [android_qrcode_url, setAndroidQrcodeUrl] = useState('data:image/png;base64,')
  // const [ios_qrcode_url, setIosQrcodeUrl] = useState('data:image/png;base64,')

  useEffect(() => {
    // const handleResize = () => {
    //   setHeight(window.innerHeight);
    // };

    // window.addEventListener('resize', handleResize);

    // 禁止页面拖拽选择文字
    document.addEventListener('selectstart', function(e) {
      e.preventDefault();
    });

    // return () => {
    //   window.removeEventListener('resize', handleResize);
    // }
  }, []);

  // 存储信息
  // getAppQrcode().then((res:any) => {
  //   setAndroidQrcodeUrl('data:image/png;base64,' + res.android_qrcode_url)
  //   setIosQrcodeUrl('data:image/png;base64,' + res.ios_qrcode_url)
  // })

  // const mouseEnter = () => {
  //   getAppQrcode()
  // }

  // const downBtnFunc = (e:any) => {
  //   e.stopPropagation()

  //   const qrcode:{[index:string]:any} = store.getState().qrcode.appQrcode;
  //   window.location.href = qrcode.pc_apk_url
  // }

  return (
    <>
      <section className="approved-home">
        <section className="app-qrcodes">
          {/* <div>
            <span className="app-qrcode-btn" onMouseEnter={mouseEnter}>
              <div className="icon iOS-icon" />
              <span>iOS下载</span>
            </span>
            <div className="img-box">
              <img className="ios_url" src={ios_qrcode_url} alt="" />
            </div>
          </div>
          <div>
            <span className="app-qrcode-btn" onMouseEnter={mouseEnter}>
              <div className="icon Andriod-icon" />
              <span>安卓下载</span>
            </span>
            <div className="img-box">
              <img className="android_url" src={android_qrcode_url} alt="" />
            </div>
          </div> */}
        </section>

        <footer>
          <div>
            <span>安徽省悠悦软件科技有限公司</span>
            <span>公司地址：安徽省铜陵市义安区东联镇毛桥街道177-201</span>
            <span>违法和不良信息举报邮箱：kefu@love-uu.com</span>
          </div>

          <div>
            <span>网站备案号：皖ICP备2023027970号-4A</span>
            <span>电信诈骗举报专区</span>
          </div>
        </footer>
      </section>
    </>
  );
}

export default Home